import { FAQSection } from "@/components/faq-section";
import { CallToActionSection } from "@/components/call-to-action-section";
import { useSEO } from "@/lib/use-seo";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Who is The AI for HR Mastermind for?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "This mastermind is for HR and People leaders who want to demystify Gen AI, spot use cases aligned with business goals, and turn their teams into the go-to company experts on AI. Ideal for HR professionals starting their AI journey, leaders networking with early adopters, those avoiding common AI implementation mistakes, HR executives playing more strategic roles, and leaders implementing evidence-based talent practices using AI.",
      },
    },
    {
      "@type": "Question",
      name: "What does the 5-session program cover?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Session 1: Understanding your AI Readiness. Session 2: Selecting a Use Case with Task-Tech Fit. Session 3: Creating an AI Assistant Proof-of-Concept. Session 4: Preparing Knowledge for AI. Session 5: Preparing to Scale — turning a working demo into adoption with a concrete rollout plan.",
      },
    },
    {
      "@type": "Question",
      name: "What if I can't make a session?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "All calls are recorded for you to watch later if you're unable to make the live sessions. In-person sessions are also recorded and available on your private community page.",
      },
    },
    {
      "@type": "Question",
      name: "What is your refund policy?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We have a no-questions-asked refund policy. If you ever feel that the program isn't meeting your expectations or isn't a good fit, we'll refund your full tuition.",
      },
    },
    {
      "@type": "Question",
      name: "What is included in the program?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Weekly interactive group training sessions, resources curated for HR leaders, reusable templates and frameworks for AI implementation, networking with HR and People leaders, access to a private community page, and recordings of all sessions for review.",
      },
    },
    {
      "@type": "Question",
      name: "How can this mastermind benefit my organization?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "It supports you confidently leading AI initiatives in your HR department — potentially reducing costs, improving efficiency, and enhancing decision-making. You'll learn to identify valuable AI use cases, build prototypes, and create action plans for implementation.",
      },
    },
    {
      "@type": "Question",
      name: "What happens when I purchase standard and want to upgrade to premium?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The cost for premium is pro-rated based on how much of your standard year membership is left, so you only pay for the additional value during the remainder of your membership period.",
      },
    },
  ],
};

export const FAQ = () => {
  useSEO({
    title: "FAQ",
    description: "Answers to common questions about the AI for HR Mastermind — who it's for, what's included, pricing, refund policy, and how to upgrade between membership tiers.",
    path: "/faq",
    jsonLd: faqJsonLd,
  });
  return (
    <div className="flex flex-col pt-32 md:pt-8">
      <FAQSection />
      <CallToActionSection />
    </div>
  );
};

export default FAQ;
